module.exports = __webpack_public_path__ + "static/media/ck.87b36328.svg";